import React, { useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Col, Container, Row, Card, CardBody, Input, Label, Button } from "@/Components/ui";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import CommonDatePicker from "@/Components/Common/CommonDatePicker";
import { API, API_USERS_CRM, BACKEND_HOST, getDataFromUrl } from "../../../api";
import Select from "react-select";
import moment from "moment";
import UserSelectBox from "../../../Components/Common/UserSelectBox";
import { dialogService } from "@/utils/dialogService";
import { useUnsavedChangesGuard } from "@/hooks/useUnsavedChangesGuard";
const B2BPreCouponForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [couponProducts, setCouponProducts] = React.useState([]);
  const [selectedCouponProduct, setSelectedCouponProduct] = React.useState(null);
  const [expireDate, setExpireDate] = React.useState(moment().add(1, "months").format("YYYY-MM-DD"));
  const [couponCount, setCouponCount] = React.useState<number | string>(1);
  const [shareCount, setShareCount] = React.useState<number | string>(1);
  const abortController = useRef(null);
  const [userList, setUserList] = React.useState([]);
  const [search, setSearch] = React.useState("");
  const [count, setCount] = React.useState(0);
  const [selectedUsers, setSelectedUsers] = React.useState([]);
  const [hasUnsavedChanges, setHasUnsavedChanges] = React.useState(false);
  const markDirty = React.useCallback(() => setHasUnsavedChanges(true), []);
  const { confirmDiscardChanges } = useUnsavedChangesGuard({
    isDirty: hasUnsavedChanges,
    confirmNavigation: dialogService.confirm,
  });
  const handleSelectedUsersChange = React.useCallback((users) => {
    markDirty();
    setSelectedUsers(users);
  }, [markDirty]);
  useEffect(() => {
    console.log("selectedUsers", selectedUsers);
  }, [selectedUsers]);
  useEffect(() => {
    if (abortController.current) {
      abortController.current.abort();
    }
    if (search) {
      abortController.current = new AbortController();
      getDataFromUrl(`${API_USERS_CRM}/?search=${search}`, abortController.current.signal)
        .then((data) => {
          console.log(data);
          setUserList(data.results);
          setCount(data.count);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [search]);
  React.useEffect(() => {
    if (id && id !== "0") {
      API.get(`${BACKEND_HOST}/precoupon/b2b-stock/${id}/`)
        .then((res) => {
          fillStates(res.data);
        })
        .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
    }
  }, [id]);
  React.useEffect(() => {
    API.get(`${BACKEND_HOST}/precoupon/precoupon`)
      .then((res) => {
        setCouponProducts(res.data.map((item) => {
          return { value: item.id, label: item.name };
        }));
      })
      .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
  }, []);
  const fillStates = (data) => {
    setSelectedCouponProduct({ value: data.precoupon.id, label: data.precoupon.name });
    setExpireDate(data.expire_date);
    setCouponCount(data.stock);
    setShareCount(data.share_count ?? 1);
    setSelectedUsers([data.user]);
  };
  const sendData = async () => {
    const data = await checkData();
    if (data === null)
      return;
    console.log(data);
    API.post(`${BACKEND_HOST}/precoupon/b2b-stock/`, data)
      .then(async (res) => {
        console.log("sendData", res.data);
        setHasUnsavedChanges(false);
        await dialogService.handleAlert("post ok");
        navigate(`/b2b-precoupon-list`);
      })
      .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
  };
  const updateData = async () => {
    const data = await checkData();
    if (data === null)
      return;
    API.put(`${BACKEND_HOST}/precoupon/b2b-stock/${id}/`, data)
      .then(async (res) => {
        console.log("updateData", res.data);
        setHasUnsavedChanges(false);
        await dialogService.handleAlert("update ok");
        navigate(`/b2b-precoupon-list`);
      })
      .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
  };
  const checkData = async () => {
    if (selectedCouponProduct === null) {
      await dialogService.handleAlert("쿠폰 상품을 선택해주세요.");
      return null;
    }
    if (!selectedUsers || selectedUsers.length === 0) {
      await dialogService.handleAlert("대상 사용자를 선택해주세요.");
      return null;
    }
    if (shareCount === "" || shareCount === null || shareCount === undefined) {
      await dialogService.handleAlert("공유 가능 수량을 입력해주세요.");
      return null;
    }
    const parsedShareCount = Number(shareCount);
    if (Number.isNaN(parsedShareCount)) {
      await dialogService.handleAlert("공유 가능 수량은 숫자만 입력 가능합니다.");
      return null;
    }
    if (parsedShareCount < 0) {
      await dialogService.handleAlert("공유 가능 수량은 0 이상이어야 합니다.");
      return null;
    }
    let data = {
      precoupon: selectedCouponProduct.value,
      expire_date: moment(new Date(expireDate)).format("YYYY-MM-DD"),
      stock: couponCount,
      share_count: parsedShareCount,
      user: selectedUsers.length > 0 ? selectedUsers[0].id : null,
    };
    return data;
  };
  return (<React.Fragment>
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="제휴쿠폰 등록 및 수정" pageTitle="쿠폰" />

        <Row className="g-4 mb-3">
          <div className="col-sm-auto">
            <div>
              <h4 className="card-title mb-0 flex-grow-1">등록 및 수정</h4>
            </div>
          </div>
          <div className="col-sm-3 ms-auto">
            <div className="d-flex justify-content-sm-end gap-2">
              {id !== "0" ? (<Button color="success" className="add-btn me-1" onClick={updateData} id="create-btn">
                Update
              </Button>) : (<Button color="success" className="add-btn me-1" onClick={sendData} id="update-btn">
                Create
              </Button>)}
              <Button color="danger" className="add-btn me-1" onClick={async () => {
                if (!await confirmDiscardChanges())
                  return;
                navigate(`/b2b-precoupon-list`);
              }} id="cancel-btn">
                Cancel
              </Button>
            </div>
          </div>
        </Row>

        <Row>
          <Col xxl={12}>
            <Card>
              <CardBody>
                <div className="live-preview">
                  <Row>
                    <Col md={12}>
                      <div className="mb-3">
                        <Label htmlFor="ForminputCouopnItem" className="form-label">
                          대상 쿠폰
                        </Label>
                        <Select name="couponProducts" options={couponProducts} className="basic-select" classNamePrefix="select" onChange={(value) => {
                          markDirty();
                          setSelectedCouponProduct(value);
                        }} value={selectedCouponProduct} />
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="mb-3">
                        <Label className="form-check-label" htmlFor="expireDate">
                          만료일
                        </Label>
                        <CommonDatePicker value={expireDate} onChange={(value) => {
                          markDirty();
                          setExpireDate(value);
                        }} className="form-control" options={{
                        }} />
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="mb-3">
                        <Label className="form-check-label" htmlFor="couponCount">
                          총 발급가능 쿠폰수량
                        </Label>
                        <Input type="number" id="couponCount" value={couponCount} onChange={(e) => {
                          markDirty();
                          setCouponCount(e.target.value);
                        }} />
                      </div>
                    </Col>

                    <Col md={4}>
                      <div className="mb-3">
                        <Label className="form-check-label" htmlFor="shareCount">
                          1인당 다운로드 가능 개수
                        </Label>
                        <Input type="number" min={0} required id="shareCount" value={shareCount} onChange={(e) => {
                          markDirty();
                          setShareCount(e.target.value);
                        }} />
                      </div>
                    </Col>

                    <Col md={12}>
                      <div className="mb-3">
                        <Label htmlFor="ForminputCouopnItem" className="form-label">
                          대상 사용자 (단일선택)
                        </Label>
                        <UserSelectBox userList={userList} setUserList={setUserList} selectedUsers={selectedUsers} setSelectedUsers={handleSelectedUsersChange} search={search} setSearch={setSearch} count={count} setCount={setCount} isMultiSelect={false} title="" />
                      </div>
                    </Col>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/* <Row>
                      <Col xxl={12}>
                          <Card>
                              <CardHeader>
                                  <h4 className="card-title mb-0">상세정보</h4>
                              </CardHeader>
                              <CardBody>
                                  <div>
                                      <textarea className="form-control" id="exampleFormControlTextarea5" rows="10" value={descript} onChange={(e) => { setDescript(e.target.value); }}></textarea>
                                  </div>
                              </CardBody>
                          </Card>
                      </Col>
                  </Row> */}
      </Container>
    </div>
  </React.Fragment>);
};
export default B2BPreCouponForm;
